import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import { toggleCountrySelector as toggleCountrySelectorAction } from '../modules';

const CountrySelectorContainer = ({ childComponent: ChildComponent, ...props }) => (
  <ChildComponent {...props} />
);

CountrySelectorContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
  props: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = ({ countrySelector, content }) => ({
  isCountrySelectorVisible: R.prop('isCountrySelectorVisible')(countrySelector),
  regions: R.path(['countrySelector', 'regions'])(content),
  current: R.path(['countrySelector', 'current'])(content),
});

const mapDispatchToProps = dispatch => ({
  toggleCountrySelector: props => dispatch(toggleCountrySelectorAction(props)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelectorContainer);
